<template>
  <div>
    <template v-if="currentEntityIsContent">
      <nx-content-editor
          modal
          :id="id"
          :relative-version-id="currentRelativeVersionId"
          :type="type"
          :channel="contentChannel"
          :language="contentLanguage"
          :disabled="blocked"
          @load="finishContentLoading"
          @updateRelativeVersionId="updateRelativeVersionId"
          ref="editor"
      ></nx-content-editor>
      <nx-layout-default-progress-bar :active="contentLoading"></nx-layout-default-progress-bar>
    </template>
    <nx-entity-editor
        v-else-if="id && type"
        modal
        :id="id"
        :entity="type"
        :title="title"
        :disabled="blocked"
        ref="editor"
        @load="finishContentLoading"
    ></nx-entity-editor>

    <nx-dialog-confirm
        :text="$t('message.content.editor.unsavedChangesConfirmText')"
        :title="$t('message.content.editor.unsavedChanges')"
        :accept-text="$t('message.content.editor.unsavedChangesAcceptText')"
        :cancel-text="$t('message.content.editor.unsavedChangesCancelText')"
        accept-color="primary"
        cancel-color="primary"
        ref="confirm"
    ></nx-dialog-confirm>
  </div>
</template>

<script>
import get from 'lodash/get';
import { mapGetters } from 'vuex';
import Blockable from '@/modules/block/mixins/blockable';
import NxEntityEditor from './EntityEditor';
import NxDialogConfirm from '@/components/dialogs/Confirm';
import NxContentEditor from '@/modules/content/editor/ContentEditor';
import NxLayoutDefaultProgressBar from '@/layouts/components/ProgressBar';

export default {
  name: 'nx-entity-modal-editor',
  mixins: [Blockable],
  components: {
    NxLayoutDefaultProgressBar,
    NxContentEditor,
    NxDialogConfirm,
    NxEntityEditor,
  },
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
    },
    entity: {
      type: Object,
    },
  },
  data() {
    return {
      contentChannel: 'master',
      contentLanguage: null,
      contentLoading: true,
      currentRelativeVersionId: null,
    };
  },
  computed: {
    ...mapGetters(['availableContentTypes']),
    currentEntityIsContent() {
      return this.id && this.type && this.availableContentTypes.includes(this.type);
    },
    title() {
      const titleFields = [
        'editorTitle',
        'name',
        'description',
        'title',
        'text',
      ];
      const match = titleFields.find(field => (this.entity ? !!this.entity[field] : false));
      if (match) {
        return this.entity[match];
      }
      return this.$t('message.entity.modal.title');
    },
    config() {
      return this.$store.getters.getEntityConfig(this.type);
    },
    address() {
      const blockable = get(this.config, 'blockable', true);
      if (this.currentEntityIsContent) {
        return {
          entity: 'content',
          type: this.type,
          id: this.id,
          language: this.contentLanguage,
        };
      }
      return {
        entity: this.type,
        id: blockable ? this.id : uuid(),
      };
    },
  },
  methods: {
    reset() {
      this.contentChannel = 'master';
      this.contentLanguage = null;
      this.contentLoading = true;
      this.currentRelativeVersionId = null;
    },
    isDirty() {
      const isDirty = this.$refs.editor.isDirty;
      return isDirty === false || (typeof isDirty === 'function' && isDirty() === false);
    },
    updateRelativeVersionId(relativeVersionId) {
      this.currentRelativeVersionId = relativeVersionId;
    },
    finishContentLoading(loading) {
      // Controlamos si de verdad se ha cargado el contenido para seguir y hacer el joinRoom
      // En el caso de un contenido bloqueado, por ejemplo, por siteMismatch no se estaba controlando
      if (loading) {
        return;
      }
      this.contentLoading = false;
      const address = {
        name: this.currentEntityIsContent ? 'content.editor' : 'entity.editor',
        params: this.address,
      };
      console.debug('[ROOM-MODAL] Joining room at', address);
      this.joinRoom(address);
      // Force currentAddress after joiningRoom to check room ownership properly
      this.currentAddress = address;
    },
  },
};
</script>
